import {FEATURE_FLAGS} from '../../../constants';

export enum EntityType {
	PROJECT = 'PROJECT',
	PHASE = 'PHASE',
	TASK = 'TASK',
	TIME_REG = 'TIME_REG',
	TICKET = 'TICKET',
}

export enum CustomFieldType {
	STRING = 'STRING',
	DROPDOWN = 'DROPDOWN',
	INTEGER = 'INTEGER',
	DECIMAL = 'DECIMAL',
	DATE = 'DATE',
}

export const EntityTypeLabels: Record<EntityType, string> = {
	[EntityType.PROJECT]: 'Project',
	[EntityType.PHASE]: 'Phase',
	[EntityType.TASK]: 'Task',
	[EntityType.TIME_REG]: 'Time Entry',
	[EntityType.TICKET]: 'Ticket',
};

export const CustomFieldTypeLabels: Record<CustomFieldType, string> = {
	[CustomFieldType.STRING]: 'Free Text',
	[CustomFieldType.DROPDOWN]: 'Dropdown',
	[CustomFieldType.INTEGER]: 'Integer',
	[CustomFieldType.DECIMAL]: 'Decimal',
	[CustomFieldType.DATE]: 'Date',
};

// The feature flag each type needs before it appears in the type picker, or null for none.
// Every type must be listed, so adding a type without deciding its flag fails the type check.
export const CUSTOM_FIELD_TYPE_FEATURE_FLAG: Record<CustomFieldType, string | null> = {
	[CustomFieldType.STRING]: null,
	[CustomFieldType.DROPDOWN]: null,
	[CustomFieldType.INTEGER]: FEATURE_FLAGS.INTEGER_DECIMAL_DATE_CUSTOM_FIELDS,
	[CustomFieldType.DECIMAL]: FEATURE_FLAGS.INTEGER_DECIMAL_DATE_CUSTOM_FIELDS,
	[CustomFieldType.DATE]: FEATURE_FLAGS.INTEGER_DECIMAL_DATE_CUSTOM_FIELDS,
};
